import { setAlert } from '@store/appStore';
import store from '@store/index';

export const showAlertMessage = (message?: string) => {
    store.dispatch(
        setAlert({
            message: message || '',
            open: true,
            severity: 'success'
        })
    );
};

/**
 * Aviso: la operación SÍ se hizo, pero hay algo que quien la hizo debe saber
 * (por ejemplo, que el CEDIS no tenía registro del insumo que acaba de recibir).
 */
export const showAlertWarning = (message?: string) => {
    store.dispatch(
        setAlert({
            message: message || '',
            open: true,
            severity: 'warning'
        })
    );
};
